import { ExperimentsBag } from '@wix/wix-experiments';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import React, { FC } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClientProvider, QueryClient } from 'react-query';
import { Router } from 'react-router-dom';
import { createHashHistory } from 'history';
import { nest } from 'recompose';
import { MMGRSettingsProvider } from '../../utils/hoc/withMMGRSettings';
import { DuplexerProvider } from '../../utils/hooks/useDuplexer';
import { LoadingErrorCatcherProvider } from '../../utils/hooks/useLoadingErrorCatcher';
import { AppEventsProvider } from '../../services/appEvents/appEvents';
import { InnerApp } from './InnerApp';
import { WDSWithColorBranding } from './WDSWithColorBranding';

const experimentsOptions = window.__EXPERIMENTS__
  ? { experiments: window.__EXPERIMENTS__ as ExperimentsBag }
  : { scope: 'media-manager-g6', baseUrl: 'https://www.wix.com' };

const Providers = nest(
  AppEventsProvider,
  LoadingErrorCatcherProvider,
  MMGRSettingsProvider,
  DuplexerProvider,
  WDSWithColorBranding,
);

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

export const appHistory = createHashHistory();

export const App: FC = () => (
  <Router history={appHistory}>
    <DndProvider backend={HTML5Backend}>
      <ExperimentsProvider options={experimentsOptions}>
        <QueryClientProvider client={queryClient}>
          <Providers>
            <InnerApp />
          </Providers>
        </QueryClientProvider>
      </ExperimentsProvider>
    </DndProvider>
  </Router>
);
